<template>
  <div>
    <p>Klienter är telefoner eller andra smarta enheter som någon gång har varit inloggade på din Nexa Bridge, det är via en klient man senare skickar notiser. Om du tar bort en klient här nedanför kommer denna inte längre att kunna få notiser.</p>
        
    <table v-if="clients.length">
      <thead>
        <tr>
          <th>Namn & enhet</th>
          <!--<th>Kan ta emot notiser</th>-->
          <!--<th align="right"></th>-->
          <th align="right">Ta bort</th>
        </tr>
      </thead>

      <tbody>
        <tr class="nohover" v-for="client in clients">
          <td width="670">
            <div>{{ client.deviceName }}</div>
            <div style="font-size:10px;">{{ client.deviceType.toLowerCase() }}</div>
          </td>
          <!--<td>{{ 'pushToken' in client && client.pushToken.length > 10 || 'deviceToken' in client ? 'Ja' : 'Nej' }}</td>-->
          <!--<td align="right" width="150"><span v-if="client.sendingPush">Skickar...</span><span v-else><a href="#" @click="testPush(client, $event)">Skicka test-notis</a></span></td>-->
          <td align="right"><a href="#" @click="remove(client.id, $event)"><span class="red">Radera</span></a></td>
        </tr>
      </tbody>
    </table>
    <div v-else>
      <i>Inga klienter har registrerat sig än, det är endast mobila enheter som registrerar sig och som det går att skicka notiser till.</i>
    </div>
  </div>
</template>

<script>
  import { HTTP } from '../http.js'

  export default {
    name: 'installningar_clients',
    data () {
      return {
        clients: []
      }
    },
    created () {
      HTTP.get('clients')
      .then(res => res.data)
      .then(json => {
        this.clients = json.map(client => {
          client.sendingPush = false
          return client
        })
      })
    },
    methods: {
      testPush (client, e) {
        e.preventDefault()

        const obj = {
          clientId: client.id,
          message: 'Notis från Nexa Bridge',
          sound: 'default',
          badge: 1
        }

        client.sendingPush = true

        HTTP.post('clients/sendPush', obj)
        .then(res => res.data)
        .then(json => {
          setTimeout(() => client.sendingPush = false, 500)
        })
      },
      
      remove (clientId, e) {
        e.preventDefault()
        
        if (confirm('Är du säker på att du vill radera den här klienten?')) {
          const index = this.clients.findIndex(c => c.id === clientId)
          this.clients.splice(index, 1)
          
          HTTP.delete('clients?clientId=' + clientId)
          .then(res => res.data)
          .then(json => {
            
          })
        }

      }
    },
    computed: {},
    destroyed () {}
  }
</script>


// WEBPACK FOOTER //
// src/components/installningar_clients.vue